import {FileUsages} from '../types';
import {useGet} from './../useHttpHooks';
import toQuery from '../../lib/toQuery.ts';

// Where one file is used: the projects the viewer can see, Help articles for content editors, counts of the rest.
const useGetFileUsages = (uri: string) =>
    useGet<FileUsages>(`/api/uploads/file-usages?${toQuery({uri})}`, {
        errorMessage: 'GET api/uploads/file-usages failed'
    });

export default useGetFileUsages;
